import type { ExactJournalEntrySortField } from '@/gql/graphql';
import { int, isoDate, oneOf, optionsOf } from '@/hooks/useUrlState';

export type ExactEntryStatusValue = 'succeeded' | 'failed';
export const EXACT_STATUS_LABELS: Record<ExactEntryStatusValue, string> = { succeeded: 'Succeeded', failed: 'Failed' };
export const EXACT_STATUS_OPTIONS = optionsOf(EXACT_STATUS_LABELS, 'All');

export type ExactSortColumn = 'recognitionDate' | 'createdAt' | 'status';

/** DataGrid column `id` → GraphQL sort field for server-side sort; its keys are the values `sort` accepts. */
export const EXACT_COLUMN_SORT: Record<ExactSortColumn, ExactJournalEntrySortField> = {
  recognitionDate: 'RECOGNITION_DATE',
  createdAt: 'CREATED_AT',
  status: 'STATUS',
};

export const EXACT_DEFAULT_SORT: { sort: ExactSortColumn; dir: 'asc' | 'desc' } = { sort: 'recognitionDate', dir: 'desc' };

/** The /exact query string, in this order (see README "List pages, URL state"). */
export const exactUrlSchema = {
  status: oneOf(EXACT_STATUS_LABELS, ''),
  from: isoDate(),
  to: isoDate(),
  sort: oneOf(EXACT_COLUMN_SORT, EXACT_DEFAULT_SORT.sort),
  dir: oneOf<'asc' | 'desc', 'asc' | 'desc'>({ asc: true, desc: true }, EXACT_DEFAULT_SORT.dir),
  page: int({ min: 1 }, 1),
  size: int({ min: 1, max: 500 }, 50),
};
